import React from 'react';
import c from 'classnames';
import { SocialLoginProvider } from '../types';
import SocialButtonBase from '../SocialButtonBase';
import SocialButtonIconViewBase from '../SocialButtonIconViewBase';
import useAppleSignIn from '../hooks/useAppleSignIn';
import s from './SocialButtonApple.scss';
const SocialButtonApple = ({ clientId, sessionId, biData, className, view = 'standard', redirectToJoin = false, redirectToSisu, attemptSocialLogin, children })=>{
    const { signIn } = useAppleSignIn(clientId, sessionId, (response)=>{
        attemptSocialLogin({
            provider: SocialLoginProvider.Apple,
            token: response.authorization.id_token,
            redirectToJoin,
            redirectToSisu
        });
    });
    const onClick = (e)=>{
        e.preventDefault();
        signIn();
    };
    if (view === 'icon') {
        return /*#__PURE__*/ React.createElement(SocialButtonIconViewBase, {
            className: c(s['root'], s['icon'], className),
            biData: biData,
            onClick: onClick
        });
    }
    return /*#__PURE__*/ React.createElement(SocialButtonBase, {
        className: c(s['root'], className),
        biData: biData,
        onClick: onClick
    }, children);
};
SocialButtonApple.displayName = 'SocialButtonApple';
export default SocialButtonApple;
